import { IResortPathInfo } from 'api/resort/types';
import { Routes } from 'routes';
import { PlanYourTrip } from './Component';
import { OuterPlanYourTripPropsType } from './types';
import { hasWeSkiIntegration, weSkiDestinationId } from './WeSki/resolver';

interface IRegionPlanYourTripProps extends OuterPlanYourTripPropsType {
  resort: IResortPathInfo,
  templateName?: string,
  isCondensed?: boolean,
}

const PlanYourTripResortWrapper = ({
  resort, templateName, isCondensed, ...props
}: IRegionPlanYourTripProps) => {
  const redirectLodgingPath = Routes.resortTripPlanningLodging(resort);
  const redirectSkiRentalPath = Routes.resortSkiRentals(resort);
  const { title_short: title } = resort;

  const lodgingProvider = hasWeSkiIntegration({ resortId: resort.uuid }) ? 'weski' : 'tripadvisor';
  const weDestinationId = lodgingProvider === 'weski' ? weSkiDestinationId({ resortId: resort.uuid }) : null;

  return (
    <PlanYourTrip
      {...props}
      contextKey="resort"
      title={title}
      redirectLodgingPath={redirectLodgingPath}
      redirectSkiRentalPath={redirectSkiRentalPath}
      lodgingProvider={lodgingProvider}
      weSkiDestinationId={weDestinationId}
      templateName={templateName}
      isCondensed={isCondensed}
      resortId={resort.uuid}
    />
  );
};

export default PlanYourTripResortWrapper;
